/**
 * Seeds a geo form's `Code` field with the code of the immediate parent
 * location, so the code that is finally saved reads as
 * `<parent code><suffix typed by the user>` (e.g. area GH0304 -> district GH030401).
 *
 * Forms using this mixin are expected to expose `new_data.code` and to call
 * `applyCodePrefix` whenever the selected parent changes.
 */
export default {
  data() {
    return {
      // The prefix currently owned by the mixin. Anything the user types after it
      // is treated as the suffix and carried over when the parent changes.
      seededCodePrefix: "",
    }
  },
  methods: {
    applyCodePrefix(prefix) {
      const next = (prefix || "").trim();
      const current = (this.new_data.code || "").trim();
      const seeded = this.seededCodePrefix;

      // A code typed by hand that never grew out of a seeded prefix is the user's,
      // so leave it alone and stop managing the field.
      if (current && !(seeded && current.startsWith(seeded))) {
        this.seededCodePrefix = "";
        return;
      }

      const suffix = seeded ? current.slice(seeded.length) : "";

      this.$set(this.new_data, "code", `${next}${suffix}`);
      this.seededCodePrefix = next;
    },
    resetCodePrefix() {
      this.seededCodePrefix = "";
    },
  },
}
